import React, { useEffect, useRef } from "react";
import GetScript from "../../../../GetScript";
import style from "./index.module.scss";
import { useUpdateEffect } from "react-use";
import { Modal } from "antd";

declare global {
    interface Window {
        polyvPlayer: any;
    }
}

interface VideoViewerProps {
    vid: string;
}

export default function VideoViewer({ vid }: VideoViewerProps) {
    const playerRef = useRef<any>(null);
    const wrapperRef = useRef<HTMLDivElement>(null);

    // const match = useRouteMatch();

    useUpdateEffect(() => {
        if (!playerRef.current) return;
        playerRef.current.changeVid({ vid, autoplay: false });
    }, [vid]);

    useEffect(() => {
        return () => {
            if (!playerRef.current) return;
            playerRef.current.destroy();
        };
    }, []);

    // 离开当前页签暂停视频
    // useUpdateEffect(() => {
    //     if(!playerRef.current) return;
    //     if(!match.path) playerRef.current.j2s_pauseVideo();
    //     if(match.path) playerRef.current.j2s_resumeVideo();
    // }, [match.path]);

    function onLoad() {
        if (!wrapperRef.current) return;

        playerRef.current = window.polyvPlayer({
            wrap: wrapperRef.current,
            height: "100%",
            vid: vid,
            autoplay: false
        });
    }

    function onError() {
        Modal.error({ content: "播放器加载失败!", getContainer });
    }

    function getContainer(): any {
        return document.querySelector(".PopupContainer");
    }

    return (
        <GetScript
            key={vid}
            src="https://player.polyv.net/script/player.js"
            onLoad={onLoad}
            onError={onError}>
            <div ref={wrapperRef} className={style.video} />
        </GetScript>
    );
}
